import { logger } from "@/lib/logger";
/**
 * unregisterConflictingServiceWorkers — Limpia SW de MSW potencialmente rotos
 * y el SW de PWA (`/sw.js`) que NO debe controlar el origen en desarrollo.
 *
 * Problema que resuelve: si un `sw.js` (PWA, scope `/`) quedó registrado en el
 * origen (p. ej. tras correr un build/preview de producción), toma control de
 * la página completa: sirve módulos stale del grafo de Vite (p. ej. archivos
 * que ya se renombraron a carpetas → 404) e impide que MSW se active (dos
 * service workers no comparten el scope). En DEV ese SW nunca se quiere.
 *
 * En DEV se ejecuta siempre y desregistra `mockServiceWorker.js` y `sw.js`.
 * En la APK (Capacitor) solo cuando se pasa `force` (bucle de recargas tras
 * actualizar el System WebView). Nunca borra datos del usuario.
 */

const STALE_SW_SCRIPTS = ["/mockServiceWorker.js", "/sw.js"];

export async function unregisterConflictingServiceWorkers(options?: {
  force?: boolean;
}): Promise<void> {
  if (!("serviceWorker" in navigator)) return;
  if (!import.meta.env.DEV && !options?.force) return;

  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      regs
        .filter((reg) => {
          const script =
            reg.active?.scriptURL ?? reg.installing?.scriptURL ?? "";
          return STALE_SW_SCRIPTS.some((s) => script.includes(s));
        })
        .map((reg) => reg.unregister()),
    );
  } catch (err) {
    logger.warn(
      "[sw] No se pudieron desregistrar service workers viejos:",
      err,
    );
  }
}
